import React, {forwardRef} from 'react'

const InputFieldValue = forwardRef((props, ref) => {
    const {id, size, maxlength, pattern, minlength, type='text', placeholder, value, className, onChange, onBlur, onClick} = props;
  return (
    <div className="wth3-inputField__box">
        <input 
            ref={ref}
            {...(id ? { id } : {})}
            {...(size ? { size } : {})}
            {...(maxlength ? { maxlength } : {})}
            {...(minlength ? { minlength } : {})}
            {...(pattern ? { pattern } : {})}
            htmlFor={id} 
            {...(type ? { type } : {})}
            {...(placeholder ? { placeholder } : {})}
            {...(value ? { value } : {})}
            aria-labelledby={`${id}-label`} 
            className={`wth3-inputField__box-input ${className}`}
            {...(onChange ? { onChange } : {})}
            {...(onBlur ? { onBlur } : {})}
            {...(onClick ? { onClick } : {})}
        >
        </input>
      </div>
  )
});

export default InputFieldValue;
